import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const FooterBottom = () => {
    const [footerData, setFooterData] = useState(null);

    useEffect(() => {
        // Fetch data from the API
        const fetchFooterData = async () => {
            try {
                const response = await fetch('https://yautiktechnology.com/api/footer');
                const data = await response.json();
                setFooterData(data[0]); // Accessing the first item in the array
            } catch (error) {
                console.error('Error fetching footer data:', error);
            }
        };

        fetchFooterData();
    }, []);

    // If footerData is not yet loaded, show a loading message
    if (!footerData) {
        return <div>Loading...</div>;
    }

    return (
        <div className="footer-bottom">
            <div className="container">
                <div className="row y-middle">
                    <div className="col-lg-6 text-right md-text-center md-mb-10 order-last">
                        <ul className="copy-right-menu">
                            {/* Manually reorder the menu items */}
                            <li><Link to={footerData.menuNameWithUrl["Home"]}>Home</Link></li>
                            <li><Link to={footerData.menuNameWithUrl["About"]}>About</Link></li>
                            <li><Link to={footerData.menuNameWithUrl["Industries"]}>Industries</Link></li>
                            <li><Link to={footerData.menuNameWithUrl["Contact"]}>Contact</Link></li>
                        </ul>
                    </div>
                    <div className="col-lg-6">
                        <div className="copyright md-text-center md-mb-10">
                            {/* Updated copyright with developer's name linked to home URL */}
                            <p>{footerData.copyright} Developed By <a href={footerData.menuNameWithUrl["Home"]} target="_blank" rel="noopener noreferrer">Yautik Technology</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FooterBottom;
